import { onboardingQueryKeys as e } from "../onboarding/useOnboardingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { usersApi as r } from "@maat/api-main";
import { authQueryKeys as i } from "@maat/store-auth";
//#region src/profile/useUploadAvatarMutation.ts
var a = () => {
	let a = n();
	return t({
		mutationFn: (e) => r.uploadAvatar(e),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: i.state() }), a.invalidateQueries({ queryKey: i.me() }), a.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { a as useUploadAvatarMutation };
